import $ from 'jquery'
let CryptoJS = require("crypto-js");
const key = CryptoJS.enc.Utf8.parse("1234123412ABCDEF");
const iv = CryptoJS.enc.Utf8.parse('ABCDEF1234123412');

export const guid = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
export function Decrypt(word) {
    const encryptedHexStr = CryptoJS.enc.Hex.parse(word);
    const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    const decrypt = CryptoJS.AES.decrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
}
export function Encrypt(word) {
    let srcs = CryptoJS.enc.Utf8.parse(word);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.ciphertext.toString().toUpperCase();
}

export const fullscreenToggel = () => {
    if (fullscreenEnable()) {
        exitFullScreen();
    } else {
        reqFullScreen();
    }
};
/**
 * esc监听全屏
 */
export const listenfullscreen = (callback) => {
    function listen() {
        callback()
    }

    document.addEventListener("fullscreenchange", function () {
        listen();
    });
    document.addEventListener("mozfullscreenchange", function () {
        listen();
    });
    document.addEventListener("webkitfullscreenchange", function () {
        listen();
    });
    document.addEventListener("msfullscreenchange", function () {
        listen();
    });
};

/**
 * 浏览器判断是否全屏
 */
export function fullscreenEnable() {
    var isFullscreen = document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen
    return isFullscreen;
}


/**
 * 浏览器全屏
 */

export function reqFullScreen() {
    if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
    } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen();
    } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
    }
}

/**
* 浏览器退出全屏
*/
export function exitFullScreen() {
    if (document.documentElement.requestFullScreen) {
        document.exitFullScreen();
    } else if (document.documentElement.webkitRequestFullScreen) {
        document.webkitCancelFullScreen();
    } else if (document.documentElement.mozRequestFullScreen) {
        document.mozCancelFullScreen();
    }
}

export function financial(x) {
    return (Number.parseFloat(x) * 100).toFixed(2);
}

export function fillUpTime(time) {
    var arr = time.split(":");

    for (var i = 0; i < arr.length; i++) {
        if (arr[i].length === 1) {
            arr[i] = "0" + arr[i]
        }
    }
    var realTime = "";
    for (var j = 0; j < arr.length; j++) {
        var a = j === 0 ? "" : ":";
        realTime = realTime + a + arr[j]
    }
    return realTime;
}
// 计算Y坐标刻度及最大值
export function barLabel(arr) {
    if (!arr || !arr.length) {
        return
    }

    var str = arr[0] + '';
    var ny = 0;
    var unit = 1;
    for (var i = 0; i < arr.length; i++) {
        if (str.length < (arr[i] + '').length || parseInt(str) < arr[i]) {
            str = arr[i] + ''
        }
    }
    if (str.length < 2) {
        ny = 10;
        unit = 1
    } else {
        ny = parseInt(str[0]) + 1;
        unit = Math.pow(10, str.length - 1);
        if (unit > 10000) {
            unit = 1 + 'w'
        }
    }
    return {
        ny: ny,
        unit: unit
    }
}


// 4位随机数
export function rand(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
}

/**
 * 分割数组创建二维数组封装
 * @param data 数组
 * @param senArrLen 需要分割成子数组的长度
 */
 export const splitArr = (data , senArrLen)=>{
    //处理成len个一组的数据
    let data_len = data.length;
    let arrOuter_len = data_len % senArrLen === 0 ? data_len / senArrLen : parseInt((data_len / senArrLen)+'') + 1;
    let arrSec_len = data_len > senArrLen ? senArrLen : data_len;//内层数组的长度
    let arrOuter = new Array(arrOuter_len);//最外层数组
    let arrOuter_index = 0;//外层数组的子元素下标
    // console.log(data_len % len);
    for (let i = 0; i < data_len; i++) {
        if (i % senArrLen === 0){
            arrOuter_index++;
            let len = arrSec_len * arrOuter_index;
            //将内层数组的长度最小取决于数据长度对len取余，平时最内层由下面赋值决定
            arrOuter[arrOuter_index-1] = new  Array(data_len % senArrLen);
            if(arrOuter_index === arrOuter_len)//最后一组
                data_len % senArrLen === 0 ?
                    len = data_len % senArrLen + senArrLen * arrOuter_index :
                    len = data_len % senArrLen + senArrLen * (arrOuter_index - 1);
            let arrSec_index = 0;//第二层数组的索引
            for (let k = i; k < len; k++) {//第一层数组的开始取决于第二层数组长度*当前第一层的索引
                arrOuter[arrOuter_index-1][arrSec_index] = data[k];
                arrSec_index++;
            }
        }
    }
    return arrOuter;
};

export const divideArrayEquallyIntoNParts = (originArr, pieces)=>{
    let [arr1, arr2] = [[], []];
    let arr2d = [arr1, arr2];
    if (originArr.length >= pieces) {
        let count = 0;
        for (let arr of arr2d) {
            count++;
            if (count != pieces) {
                arr.push(...originArr.slice(Math.round(originArr.length / pieces) * (count - 1), Math.round(originArr.length / pieces) * count));
            } else {
                arr.push(...originArr.slice(Math.round(originArr.length / pieces) * (count - 1)));
            }
        }
        return [arr1, arr2];
    }
}

export const  exportFile = (content, customFileName, type) => {
    let blob = new Blob([content], {type: type || 'application/vnd.ms-excel'}) // 默认excel xls
    let filename = content.filename || customFileName;
    let URL = window.URL || window.webkitURL;
    let objectUrl = URL.createObjectURL(blob);
    let a = document.createElement('a');
    a.href = objectUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
}

export const randomString = (len) => {
    len = len || 8;
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    var maxPos = $chars.length;
    var pwd = '';
    for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
}

export const isJSON = (str) => {
    if(typeof str == 'string'){
        try {
           let obj = JSON.parse(str);
           if(typeof obj == 'object' && obj){
              return true;
           } else{
            return false;
           }
        } catch (e) {
            return false
        }
    }else{
        return false
    }
}

// 下划线转换成驼峰
export const toHump = (name) => {
    return name.replace(/\_(\w)/g, function(all, letter){
        return letter.toUpperCase();
    });
}
// toHump('a_b_c') // aBC


// 驼峰转换下划线
export const toLine = (name) => {
    return name.replace(/([A-Z])/g,"_$1").toLowerCase();
}
// toLine('aBcdEfg') //a_bcd_efg